module.exports = __webpack_public_path__ + "img/fechar.7e640e68.svg";